import React from 'react';
import OfflineStatus from '../OfflineStatus/OfflineStatus';
import LeftHeader from './LeftHeader';
import RightHeader from './RightHeader';
import styles from './Header.module.css';

/**
 * The mind map's top bar: logo, title over the save status and the map tools
 * on the left; people, apps, theme and account on the right. Below 768px the
 * tools and desktop actions fold into the right-hand menu. `my-header` is the
 * hook printMindMap.css uses to keep the bar off the printout.
 */
const Header = () => (
    <header className={`my-header ${styles.header}`}>
        <LeftHeader />
        <RightHeader />
        <div className={styles.banner}>
            <OfflineStatus />
        </div>
    </header>
);

export default Header;
